import React from "react";
import { useSelector } from "react-redux";
import "./topBar.css";
import { S3_BASE_URL } from "../../../Service";
const TopHeader = () => {
  const siteData = useSelector(
    (state) => state.data.sitesetting?.siteSetting?.[0]?.data
  );
  const getLogoUrl = (url) => {
    if (!url) return "";
    return url.startsWith("https") ? url : `${S3_BASE_URL}${url}`;
  };

  return (
    <div className="topbar-area hidden-md" id="extraP">
      <div className="container">
        <div className="row">
          <div className="col-lg-2">
            <div className="logo-part">
              <a href="/">
                <img src={getLogoUrl(siteData?.logos?.[0])} alt="Logo" />
              </a>
            </div>
          </div>
          <div className="col-lg-10 text-right">
            <ul className="rs-contact-info">
              <li className="contact-part">
                <i className="flaticon-email"></i>
                <span className="contact-info">
                  <span>E-mail</span>
                  <a
                    href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=info@techniajz.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {siteData.email}
                  </a>
                </span>
              </li>
              <li className="contact-part">
                <i className="flaticon-call"></i>
                <span className="contact-info">
                  <span>Phone</span>
                  <a href="tel:+919654652847">{siteData.phones}</a>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* {!htmlContent ? (
        ""
      ) : (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      )} */}
    </div>
  );
};

export default TopHeader;
